export const LiveCallTypes = {
  InstantLiveCall: 'instantLiveCall'
}
